import { useEffect, useState } from "react";

export function getMotionMode({ reduced, coarse }) {
  if (reduced) return "static";
  return coarse ? "touch" : "full";
}

export function useMotionPreferences() {
  const read = () => ({
    reduced: window.matchMedia("(prefers-reduced-motion: reduce)").matches,
    coarse: window.matchMedia("(pointer: coarse)").matches
  });
  const [preferences, setPreferences] = useState(read);

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
    const coarse = window.matchMedia("(pointer: coarse)");
    const update = () => setPreferences(read());

    reduced.addEventListener("change", update);
    coarse.addEventListener("change", update);
    return () => {
      reduced.removeEventListener("change", update);
      coarse.removeEventListener("change", update);
    };
  }, []);

  return { ...preferences, mode: getMotionMode(preferences) };
}
